/**
 * Параметры фильтрации мероприятий
 */

export interface EventsForm {
  /**
   * Мероприятия с датой начала позже указанной (>=)
   * @format date-time
   */
  date_from?: Date;

  /**
   * Мероприятия с датой начала раньше указанной (<=)
   * @format date-time
   */
  date_to?: Date;

  /**
   * Количество записей в выборке
   * @default 16
   */
  limit?: number;

  /**
   * Смещение относительно первого элемента
   * @default 0
   */
  offset?: number;

  ground?: string;

  /**
   * Варианты регистрации
   */
  reg_type?: Record<string, boolean>;

  /**
   * Состояния мероприятия
   */
  state?: Record<string, boolean>;

  /**
   * Подтипы мероприятия (обновляются динамически)
   */
  subtype?: Record<string, boolean>;

  /**
   * Глобальные типы мероприятия (обновляются динамически)
   */
  type?: Record<string, boolean>;
}

export class EventsDTO {
  /**
   * Мероприятия с датой начала позже указанной (>=)
   * @format date-time
   */
  date_from?: string;

  /**
   * Мероприятия с датой начала раньше указанной (<=)
   * @format date-time
   */
  date_to?: string;

  ground?: string;

  /**
   * Количество записей в выборке
   * @default 16
   */
  limit?: string;

  /**
   * Смещение относительно первого элемента
   * @default 0
   */
  offset?: string;

  /**
   * Варианты регистрации
   */
  reg_type?: string[];

  /**
   * Состояния мероприятия
   */
  state?: string[];

  /**
   * Подтипы мероприятия (обновляются динамически)
   */
  subtype?: string[];

  /**
   * Глобальные типы мероприятия (обновляются динамически)
   */
  type?: string[];

  [key: string]: string | number | Date | string[] | undefined;
}

function arrayToObject(arr: string[] | undefined): Record<string, boolean> | undefined {
  if (!arr) return undefined;
  return arr.reduce((acc, key) => {
      acc[key] = true;
      return acc;
  }, {} as Record<string, boolean>);
}

function objectToArray(obj: Record<string, boolean> | undefined): string[] | undefined {
  if (!obj) return undefined;
  return Object.entries(obj)
      .filter(([_, value]) => value)
      .map(([key]) => key);
}

const toBackDateFormat = (date: Date) => {
  const isoString = date.toISOString(); // "2025-04-18T08:00:00.000Z"
  return  isoString.split('T')[0];

}
export function convertToEventsForm(dto: EventsDTO): EventsForm {
  return {
      ...dto,
      offset: Number(dto.offset),
      limit: Number(dto.limit),
      date_from: new Date(dto.date_from|| ''),
      date_to: new Date(dto.date_to|| ''),
      reg_type: arrayToObject(dto.reg_type),
      state: arrayToObject(dto.state),
      subtype: arrayToObject(dto.subtype),
      type: arrayToObject(dto.type)
  };
}

export function convertToEventsDTO(form: EventsForm): EventsDTO {

  return {
    ...form,
      offset: form.offset?.toString(),
      limit: form.limit?.toString(),
      date_from: form.date_from && toBackDateFormat(form.date_from),
      date_to: form.date_to && toBackDateFormat(form.date_to),
      reg_type: objectToArray(form.reg_type),
      state: objectToArray(form.state),
      subtype: objectToArray(form.subtype),
      type: objectToArray(form.type)
  };
}

export function convertEventsDTOToUrlParams(myDto:EventsDTO) {
  const params = new URLSearchParams();
  Object.entries(myDto).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(v => params.append(key, v));
    } else if (!!value) {
      params.set(key, String(value));
    }
  });

  return params

}